import React, { useState, useEffect, useMemo,useCallback } from "react";
import {
  TextArea,
  Dropdown,
  Input,
  Form,
  Dimmer,
  Loader,
  Image,
} from "semantic-ui-react";

import location_icon from "../../../Assets/Icons/location_on.jpg";
import sub_location_icon from "../../../Assets/Icons/pin_drop.png";
import { useSelector } from "react-redux";

import { selectTranslations } from "../../config/i18n/slice";
import AddCustomerModal from "./popups/add-customer";
import AddLocationModal from "./popups/add-location";
import { LetteredAvatarImageUrl } from "../../components/common/userProfilePlaceholder";
import { toast } from "react-toastify";
import { scrollToError } from "../../../utilFunctions/scrollToError";
import Asterisk from "../../components/common/Asterisk";
import {
  AddIconWithCircle,
  CloseIcon,
  DeleteIcon,
  EditWhiteIcon,
  ImgPhotos,
  TextSnippet,
} from "../../../Assets/Icons/svg";
import ToolTip from "react-power-tooltip";
import { Resizable } from "re-resizable";
import useNewCancelModal from "../../../hooks/Messages/useNewCncelModal";
import ImageCrop from "../MyCompanyProfile/ImageCrop";
import { useDropzone } from "react-dropzone";
import { getAllCustomers } from "../../config/sharedApi/customerApis";
import { uploadFile, urlToFile } from "../../config/api/configApis";
import { getAllParentLocations } from "../../config/sharedApi/locationApis";
import { getActiveUsersByRole } from "../../config/sharedApi/peopleApis";
import { updateTeam } from "../../config/sharedApi/teamApis";
import {
  buildTeamValidation,
  makeOnBlurFactory,
  makeTeamValidateOnSubmitFactory,
  makeTeamOnValuesChangeFactory,
  } from "./TeamsValidationRules";

const FileUpload = ({
  onFileChange,
  name = "",
  attachments = {},
  setAttachments = () => {},
  setImageSrc = () => {},
  setFile = () => {},
  setPersonalImgId = () => {},
}) => {
  const fileTypes = {
    images: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image/svg+xml",
      "image/webp",
      "image/heic",
    ],
    documents: [
      "text/plain",
      "application/pdf",
      "text/csv",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ],
    video: ["video/mp4", "video/quicktime", "video/webm", "video/hevc"],
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      const allowedFileTypes = [...fileTypes.images];

      const invalidFiles = acceptedFiles.filter(
        (file) => !allowedFileTypes.includes(file.type)
      );

      if (invalidFiles?.length > 0) {
        toast.error(t.common.invalid_msg);
        return;
      }

      let totalSize = organisationImage?.attachmentsSize
        ? organisationImage?.attachmentsSize
        : 200;
      const validFiles = acceptedFiles.filter((file) => {
        const isImage = fileTypes.images.includes(file.type);
        const isDocument = fileTypes.documents.includes(file.type);

        const isVideo = fileTypes.video.includes(file.type);

        const validSize =
          (isVideo || isImage || isDocument) &&
          file.size < totalSize * 1024 * 1024;

        if (!validSize) {
          toast.error(
            `${t.common.file_upload_valid} ${totalSize} ${t.common.file_upload_second}`
          );
          return false;
        }
        return true;
      });

      onFileChange(validFiles, name);
    },
  });
  const t = useSelector(selectTranslations);
  const organisationImage = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation;
    } else {
      return null;
    }
  });

  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      {name === "image" ? (
        attachments?.image?.name ? (
          <div className="user-img-avatar position-relative">
            <Image
              avatar
              title={attachments?.image?.name}
              src={`${attachments?.image?.url}`}
            
            ></Image>
            <span
              className={`people-circle-image ${
                selectedLanguage == "en" ? "" : "rtl-people"
              }`}
            >
              <span
                className={`edit-container ${
                  selectedLanguage == "en" ? "" : "rtl-edit"
                }`}
              >
                <EditWhiteIcon /> {t.common.edit}
              </span>
            </span>

            <span
              className="ml-3 mr-3 c-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setPersonalImgId(null);
                setFile("");
                setImageSrc("");
                setAttachments({
                  ...attachments,
                  image: null,
                });
              }}
            >
              <DeleteIcon />
            </span>
          </div>
        ) : (
          <div className="image-dropzone  text-center mb-5">
            <div>
              <p className="p1">
                <div className="d-flex align-items-start justify-content-center ">
                  <div>
                    {" "}
                    <ImgPhotos />
                  </div>
                  <div
                    className={`mr-2 ml-2 ${
                      selectedLanguage == "en" ? "text-left" : "text-right"
                    }`}
                  >
                    {" "}
                    <div className="blue-text">
                      {" "}
                      {t.common.upload_img}
                    </div>{" "}
                    <p className="mb-0 files-text">
                      {" "}
                      {t.common.valid_files_img}
                    </p>{" "}
                  </div>
                </div>
              </p>
            </div>
          </div>
        )
      ) : attachments?.warrantyFile?.name ? (
        <div className="warrenty-file-dropzone text-center">
          <label>
            {attachments?.warrantyFile?.name}
            <span
              className="ml-3 mr-3 c-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setAttachments({
                  ...attachments,
                  warrantyFile: null,
                });
              }}
            >
              <DeleteIcon />
            </span>
          </label>
        </div>
      ) : (
        <div className="warrenty-file-dropzone d-flex align-items-center justify-content-between">
          <div className="d-flex ml-4 mr-4">
            <TextSnippet />
            <div className="pl-4 pr-4">
              <p className="p1 m-0">Warranty file</p>
              <p className="p2 m-0">Attach a file to this asset</p>
            </div>
          </div>
          <div>
            <AddIconWithCircle />
          </div>
        </div>
      )}
    </div>
  );
};
function Edit({
  targetedData,
  toggled,
  untoggle,
  setFilterOptions,
  setSearchTitle,
  setSortData,
  userRole,
  allIds,
}) {
  const t = useSelector(selectTranslations);
  const organisationId = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation.id;
    } else {
      return null;
    }
  });

  const [initChange, setInitChange] = useState(false);
  const { setNewCancelModal, NewCancelModal } = useNewCancelModal();
  const [showCancleTooltip, setCancleTooltip] = useState(false);
  const [matchingCustomers, setMatchingCustomers] = useState("");
  const [buttonStatus, setButtonStatus] = useState(0);
  const [responseData, setResponseData] = useState({});
  const [fetchLocOptions, setFetchLocOptions] = useState(true);
  const [addCustomerModal, toggleAddCustomerModal] = useState(false);
  const [addLocationModal, toggleAddLocationModal] = useState(false);
  const [customerText, setCustomerText] = useState("");
  const [locationText, setLocationText] = useState("");
  const [modalWidth, setModalWidth] = useState(
    Math.max(window.innerWidth / 2, 514)
  );
  const roles = [
    {
      key: 0,
      value: 5,
      text: t.people.add_modal.admin,

      description: t.people.add_modal.admin_description,
    },
    {
      key: 0,
      value: 4,
      text: t.people.add_modal.super_admin,
      description: t.people.add_modal.admin_description,
    },

    {
      key: 2,
      value: 9,
      text: t.people.add_modal.limited_admin,

      description: t.people.add_modal.limited_admin_description,
    },
    {
      key: 1,
      value: 8,
      text: t.people.add_modal.technician,

      description: t.people.add_modal.user_description,
    },

    {
      key: 3,
      value: 3,
      text: t.people.add_modal.viewer,

      description: t.people.add_modal.viewer_description,
    },
  ];
  const [fetchingSuperiors, setFetchingSuperiors] = useState(true);
  const [fetchingMembers, setFetchingMembers] = useState(true);
  const [fetchingCustomer, setFetchingCustomer] = useState(true);
  const [fetchingLocations, setFetchingLocations] = useState(true);
  const [file, setFile] = useState(""); //
  const [personalImgId, setPersonalImgId] = useState();
  const [attachments, setAttachments] = useState({
    image: null,
  });
  const [imageSrc, setImageSrc] = useState("");
  const [options, setOptions] = useState({
    supervisors: [],
    users: [],
    locations: {
      initOptions: [],
      options: [],
    },
    customers: [],
  });

  const [data, setData] = useState({
    name: "",
    description: "",
    users: [],
    customers: [],
    selectedLocation: [],
    locations: [],
    superior: "",
  });

  const [validation, setValidation] = useState(buildTeamValidation(t));

  const [validForm, setValidForm] = useState(false);

  useEffect(() => {
    if (toggled && targetedData) {
      fetchOptions();

      if (targetedData) {
        setData({
          ...data,
          name: targetedData?.attributes.name,
          description: targetedData?.attributes.description,
          superior: targetedData?.attributes?.superior?.data?.id,
          customers: targetedData?.attributes?.customers?.data?.length > 0
              ? targetedData?.attributes.customers.data.map(
                  (el_loc) => el_loc.id
                )
              : [],
          selectedLocation:
            targetedData?.attributes?.locations?.data?.length > 0
              ? targetedData?.attributes.locations.data.map(
                  (el_loc) => el_loc.id
                )
              : [],
          users:
            targetedData?.attributes.users.data?.length > 0
              ? targetedData?.attributes.users.data.map((el_user) => el_user.id)
              : [],
        });

        setAttachments({
          ...attachments,
          image: targetedData?.attributes?.images?.data
            ? {
                id: targetedData?.attributes?.images?.data.id,
                file: urlToFile(
                  targetedData?.attributes?.images?.data.attributes.url,
                  targetedData?.attributes?.images?.data.attributes.name
                ),
                url: targetedData?.attributes?.images?.data.attributes.url,
                name: targetedData?.attributes?.images?.data.attributes.name,
                type: targetedData?.attributes?.images?.data.attributes.mime,
                cancelPopup: false,
                isChanged: false,
              }
            : null,
        });
      }
    }
  }, [targetedData, toggled]);

  const fetchOptions = async () => {
    const [customers, locations, supervisors, users] = await Promise.all([
      getAllCustomers(
        organisationId,
        "",
        1,
        99999,
        []
      ),
      getAllParentLocations(
        organisationId,
        "",
        1,
        99999,
        [],
        [],
        [],
        ["name:asc"]
      ),
      getActiveUsersByRole(
        ["admin", "limited_admin"],
        organisationId,
         [],
        true
      ),
      getActiveUsersByRole(
        [
          "user",
          "supervisor",
          "view_only",
          "admin",
          "requester",
          "limited_admin",
        ],
        organisationId,
         [],
        true
      ),
    ]);

    let customers_options = [];
    if (customers.response) {
      customers_options = customers.response.map((el) => {
        const the_image = el.attributes.logo.data
          ? el.attributes.logo.data.attributes.url
          : LetteredAvatarImageUrl(el.attributes.name);
        return {
          key: el.id,
          value: el.id,
          text: el.attributes.name,
          image: { avatar: true, src: the_image, size: "tiny" },
          locations:
            el?.attributes?.locations?.data?.map((el_loc) => ({
              id: el_loc?.id,
              parentId: el_loc?.attributes?.parentLocation?.data?.id || null, // Add parentId if available
            })) || [],
        };
      });

      setFetchingCustomer(false);
    }

    let parentOptions = [];
    let subOptions = [];
    let the_options = [];
    let all_options = [];
    if (locations?.response?.length > 0) {
      locations.response.forEach((el) => {
        if (!(userRole === "super_admin")) {
          if (allIds?.includes(el.id)) {
            parentOptions.push({
              key: el.id,
              value: el.id,
              text: el.attributes.name,
              image: { src: location_icon },
              className: "main-location-dropdown-option",
              disabled: false,
            });

            if (el?.attributes?.subLocations?.data?.length > 0) {
              el.attributes.subLocations.data.forEach((subEl) => {
                if (allIds.includes(subEl.id)) {
                  subOptions.push({
                    key: subEl.id,
                    value: subEl.id,
                    text: subEl.attributes.name,
                    image: { src: sub_location_icon },
                    className: "sub-location-dropdown-option",
                    parentId: el.id,
                  });
                }
              });
            }
          } else {
            const hasMatchingSubLocation = el?.attributes?.subLocations?.data?.some(
              (subEl) => allIds?.includes(subEl.id)
            );

            if (hasMatchingSubLocation) {
              parentOptions.push({
                key: el.id,
                value: el.id,
                text: el.attributes.name,
                image: { src: location_icon },
                className: "main-location-dropdown-option",
                disabled: true,
              });

              el?.attributes?.subLocations?.data?.length > 0 &&
                el.attributes.subLocations.data.forEach((subEl) => {
                  if (allIds.includes(subEl.id)) {
                    subOptions.push({
                      key: subEl.id,
                      value: subEl.id,
                      text: subEl.attributes.name,
                      image: { src: sub_location_icon },
                      className: "sub-location-dropdown-option",
                      parentId: el.id,
                    });
                  }
                });
            }
          }
        } else {
          parentOptions.push({
            key: el.id,
            value: el.id,
            text: el.attributes.name,
            disabled: false,
            image: { src: location_icon },
            className: "main-location-dropdown-option",
          });

          if (el?.attributes?.subLocations?.data?.length > 0) {
            el.attributes.subLocations.data.forEach((subEl) => {
              subOptions.push({
                key: subEl.id,
                value: subEl.id,
                text: subEl.attributes.name,
                image: { src: sub_location_icon },
                className: "sub-location-dropdown-option",
                parentId: el.id,
              });
            });
          }
        }
      });
      subOptions.sort((a, b) => a.text.localeCompare(b.text));

      parentOptions.forEach((parentOption) => {
        the_options.push(parentOption);
        all_options.push(parentOption);

        subOptions.forEach((subOption) => {
          if (subOption.parentId === parentOption.key) {
            the_options.push(subOption);
            all_options.push(subOption);
          }
        });
      });

      let locationsData =
        targetedData?.attributes?.locations?.data?.length > 0
          ? targetedData?.attributes.locations.data.map((el_loc) => el_loc.id)
          : [];

      let result = [];
      let removedIds = [];

      locationsData?.length > 0 &&
        locationsData.forEach((id) => {
          const option = all_options.find((o) => o.key == id);

          if (option) {
            if (option.parentId) {
              const parentOption = all_options.find(
                (o) => o.key == option.parentId && o.disabled === false
              );

              if (locationsData?.includes(parentOption?.key)) {
                result.push(parentOption.id);

                all_options = all_options.filter((o) => o.key != id);
                removedIds.push(id);
              } else {
                result.push(id);
              }
            } else {
              result.push(id);
            }
          }
        });

      let finalResult = result.filter((result) => result !== undefined);

      setData((prev) => {
        return {
          ...prev,
          locations: [...new Set(finalResult)],
        };
      });

      setFetchLocOptions(false);
    }

    let supervisors_options = [];
    if (supervisors.data) {
      supervisors_options = supervisors.data.map((el) => {
        const the_image = el?.profileImage?.url
          ? el?.profileImage?.url
          : LetteredAvatarImageUrl(el?.firstName + " " + el?.lastName);
        return {
          key: el.id,
          value: el.id,
          text:
            el.firstName +
            " " +
            el.lastName +
            " (" +
            t.people.roles[el.role.name] +
            ")",
          image: { avatar: true, src: the_image, size: "tiny" },
        };
      });

      setFetchingSuperiors(false);
    }

    let users_options = [];
    if (users.data) {
      users_options = users.data.map((el) => {
        const the_image = el?.profileImage?.url
          ? el?.profileImage?.url
          : LetteredAvatarImageUrl(el?.firstName + " " + el?.lastName);
        return {
          key: el.id,
          value: el.id,
          text:
            el.firstName +
            " " +
            el.lastName +
            " (" +
            t.people.roles[el.role.name] +
            ")",

          image: { avatar: true, src: the_image, size: "tiny" },
        };
      });

      setFetchingMembers(false);
    }

    setOptions({
      ...options,
      supervisors: supervisors.data?.length > 0 ? supervisors_options : [],
      users: users.data?.length > 0 ? users_options : [],
      customers: customers.response?.length > 0 ? customers_options : [],
      locations:
        locations?.response?.length > 0
          ? {
              initOptions: the_options,
              options: all_options,
            }
          : {
              initOptions: [],
              options: [],
            },
    });
  };

  const resetForm = () => {
    setData({
      ...data,
      name: "",
      selectedLocation: [],
      description: "",
      users: [],
      customers: [],
      locations: [],
      superior: "",
    });
    setFetchLocOptions(true);
    setModalWidth(Math.max(window.innerWidth / 2, 514));
    setMatchingCustomers("");
    setValidation(buildTeamValidation(t));

    setFetchingSuperiors(true);
    setFetchingMembers(true);
    setFetchingCustomer(true);
    setFetchingLocations(true);
    setInitChange(false);
  };

  const fetchSupervisorsData = async () => {
    const fetchData = await getActiveUsersByRole(
      ["admin", "limited_admin"],
      organisationId,
      [],
      true
    );

    if (fetchData?.data) {
      let g_users = fetchData.data.map((el) => {
        const the_image = el?.profileImage?.url
          ? el?.profileImage?.url
          : LetteredAvatarImageUrl(el?.firstName + " " + el?.lastName);
        return {
          key: el.id,
          value: el.id,
          text:
            el.firstName +
            " " +
            el.lastName +
            " (" +
            t.people.roles[el.role.name] +
            ")",
          image: { avatar: true, src: the_image, size: "tiny" },
        };
      });
      setOptions({
        ...options,
        supervisors: g_users,
      });
    }
  };

  const fetchUsersData = async () => {
    const fetchData = await getActiveUsersByRole(
      [
        "user",
        "supervisor",
        "view_only",
        "admin",
        "limited_admin",
        "requester",
      ],
      organisationId,
      [],
      true
    );

    if (fetchData?.data) {
      let g_users = fetchData.data.map((el) => {
        let role = roles.find((each) => each.value == el.role.id);

        const the_image = el?.profileImage?.url
          ? el?.profileImage?.url
          : LetteredAvatarImageUrl(el?.firstName + " " + el?.lastName);

        return {
          key: el.id,
          value: el.id,
          text:
            el.firstName +
            " " +
            el.lastName +
            " (" +
            t.people.roles[el.role.name] +
            ")",
          image: { avatar: true, src: the_image, size: "tiny" },
        };
      });

      setOptions({
        ...options,
        users: g_users,
      });
    }
  };

  const fetchCustomerOptions = async () => {
    const fetchData = await getAllCustomers(
      organisationId,
      "",
      1,
      99999,
       []
    );

    if (fetchData.response) {
      let the_options = fetchData.response.map((el) => {
        const the_image = el.attributes.logo.data
          ? el.attributes.logo.data.attributes.url
          : LetteredAvatarImageUrl(el.attributes.name);
        return {
          key: el.id,
          value: el.id,
          text: el.attributes.name,
          image: { avatar: true, src: the_image, size: "tiny" },
          locations:
            el?.attributes?.locations?.data?.map((el_loc) => ({
              id: el_loc?.id,
              parentId: el_loc?.attributes?.parentLocation?.data?.id || null, // Add parentId if available
            })) || [],
        };
      });
      setOptions((prev) => {
        return {
          ...prev,
          customers: the_options,
        };
      });

      return the_options;
    }
  };

  const onFileChange = (files, name) => {
    setInitChange(true);
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      setImageSrc(reader.result);
    });
    reader.readAsDataURL(files[0]);

    setFile({
      name: files[0]?.name,
      type: files[0]?.type,
    });
  };

  const fetchLocationsOptions = async (updatedAllIds = []) => {
    let finalIds = [...allIds];

    const fetchData = await getAllParentLocations(
      organisationId,
      "",
      1,
      99999,
      [],
      [],
      [],
      ["name:asc"]
    );
    let the_options = [];
    let parentOptions = [];
    let subOptions = [];
    if (fetchData?.response?.length > 0) {
      fetchData.response.forEach((el) => {
        if (!(userRole === "super_admin")) {
          if (finalIds?.includes(el.id)) {
            parentOptions.push({
              key: el.id,
              value: el.id,
              text: el.attributes.name,
              image: { src: location_icon },
              className: "main-location-dropdown-option",
              disabled: false,
            });

            if (el?.attributes?.subLocations?.data?.length > 0) {
              el.attributes.subLocations.data.forEach((subEl) => {
                if (finalIds?.includes(subEl.id)) {
                  subOptions.push({
                    key: subEl.id,
                    value: subEl.id,
                    text: subEl.attributes.name,
                    image: { src: sub_location_icon },
                    className: "sub-location-dropdown-option",
                    parentId: el.id,
                  });
                }
              });
            }
          } else {
            const hasMatchingSubLocation = el?.attributes?.subLocations?.data?.some(
              (subEl) => finalIds?.includes(subEl.id)
            );

            if (hasMatchingSubLocation) {
              parentOptions.push({
                key: el.id,
                value: el.id,
                text: el.attributes.name,
                image: { src: location_icon },
                className: "main-location-dropdown-option",
                disabled: true,
              });

              el?.attributes?.subLocations?.data?.length > 0 &&
                el.attributes.subLocations.data.forEach((subEl) => {
                  if (finalIds?.includes(subEl.id)) {
                    subOptions.push({
                      key: subEl.id,
                      value: subEl.id,
                      text: subEl.attributes.name,
                      image: { src: sub_location_icon },
                      className: "sub-location-dropdown-option",
                      parentId: el.id,
                    });
                  }
                });
            }
          }
        } else {
          parentOptions.push({
            key: el.id,
            value: el.id,
            text: el.attributes.name,
            disabled: false,
            image: { src: location_icon },
            className: "main-location-dropdown-option",
          });

          if (el?.attributes?.subLocations?.data?.length > 0) {
            el.attributes.subLocations.data.forEach((subEl) => {
              subOptions.push({
                key: subEl.id,
                value: subEl.id,
                text: subEl.attributes.name,
                image: { src: sub_location_icon },
                className: "sub-location-dropdown-option",
                parentId: el.id,
              });
            });
          }
        }
      });

      subOptions.sort((a, b) => a.text.localeCompare(b.text));

      parentOptions.forEach((parentOption) => {
        the_options.push(parentOption);

        subOptions.forEach((subOption) => {
          if (subOption.parentId === parentOption.key) {
            the_options.push(subOption);
          }
        });
      });

      setOptions((prev) => ({
        ...prev,
        locations: {
          initOptions: the_options,
          options: the_options,
        },
      }));

      return the_options;
    }
  };
  const handleAddCustomer = (e, { value }) => {
    setCustomerText(value);

    toggleAddCustomerModal(true);
  };

  const returnAddCustomer = (id) => {
    fetchCustomerOptions().then((resp_data) => {
      if (resp_data.map((option) => option.value).includes(id)) {
        setData({
          ...data,
          customer: id,
        });
      }
    });
  };
  const handleAddLocation = (e, { value }) => {
    setLocationText(value);
    toggleAddLocationModal(true);
  };

  const returnAddLocation = (id) => {
    fetchLocationsOptions(data.customer).then((resp_data) => {
      if (resp_data.map((option) => option.value).includes(id)) {
        setData({
          ...data,
          locations: [...data.locations, id],
        });
      }
    });
  };

  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  const getDataSnapshot = useCallback(() => data, [data]);
  const getOptionsSnapshot = useCallback(() => options, [options]);

  const onBlur = useMemo(
      () => makeOnBlurFactory({ getData: getDataSnapshot, setValidation }),
      [getDataSnapshot, setValidation]
  );

  const onValuesChange = useMemo(
   () =>
    makeTeamOnValuesChangeFactory({
      getData: getDataSnapshot,
      setData,
      setValidation,
      setInitChange,
      getOptions: getOptionsSnapshot,
      setOptions,
      t,
      setMatchingCustomers,
      }),
      [
      getDataSnapshot,
    setData,
    setValidation,
    setInitChange,
    getOptionsSnapshot,
    setOptions,
    t,
    setMatchingCustomers,
    ]
    );

  const validateOnSubmit = React.useMemo(
      () =>
          makeTeamValidateOnSubmitFactory({
                getData: getDataSnapshot,
                validation,
                setValidation,
                getOptions: getOptionsSnapshot,
                t,
                setMatchingCustomers,
          }),
      [getDataSnapshot, validation, setValidation, getOptionsSnapshot, t, setMatchingCustomers]
  );


  useEffect(() => {
    const validationToArray = Object.entries(validation);
    const cond = validationToArray.some((el) => el[1].error && el[1].skipped);
    //

    if (initChange) setValidForm(!cond);
  }, [validation, initChange]);

  const updateTeamHandler = async () => {
    let errorsInData = validateOnSubmit();

    if (!errorsInData) {
      setButtonStatus(1);

      const response = await updateTeam(
        targetedData?.id,
        data.name,
        data.description,
        data.users,
        data.superior,
        data?.selectedLocation ? data.selectedLocation : null,
        organisationId,
        data?.customer,
        personalImgId ? personalImgId : null
      );

      if (response.status == 200) {
        setButtonStatus(0);
        untoggle();
        resetForm();

        setResponseData({
          id: response.data.id,
          name: response.data.name,
        });
        setFilterOptions({
          locations: [],
          customers: [],
          teams: [],
          superior: [],

          priority: [],
          status: [],
        });
        setSortData([]);
        setSearchTitle("");
        toast.success(t.teams.add + " " + t.common.updated_success);
      } else if (response.status == 400) {
        if (response.error && response.error.message) {
          toast.error(response.error.message);
        } else {
          toast.error(t.common.something_wrong);
          untoggle();
          resetForm();
        }
      }
      setButtonStatus(0);
    } else {
      scrollToError();
    }
  };

  const cancelHandler = () => {
    resetForm();
    setModalWidth(Math.max(window.innerWidth / 2, 514));
    untoggle();
    setNewCancelModal(false);
    setInitChange(false);
  };

  return (
    <>
      <div
        clearing
        style={{ maxWidth: `${modalWidth}px` }}
        className={
          toggled ? "aside-modal active procedure" : "aside-modal procedure"
        }
      >
        <Resizable
          size={{ width: modalWidth, height: "auto" }}
          minWidth={"514px"}
          onResize={(e, direction, ref, d) => {
            setModalWidth(ref.offsetWidth);
          }}
        >
          <div className="modal-header">
            <div className="flexbox justify-between">
              <div className="name">
                {t.teams.team_preview.edit_team} #
                {targetedData?.attributes?.countId}
              </div>
              <div>
                <span
                  className="position-relative c-pointer"
                  onMouseOver={() => setCancleTooltip(true)}
                  onMouseLeave={() => setCancleTooltip(false)}
                  onClick={() =>
                    initChange ? setNewCancelModal(true) : cancelHandler()
                  }
                >
                  <CloseIcon />
                  <ToolTip
                    color="#fff"
                    backgroundColor="#172B4D"
                    position={
                      selectedLanguage == "en"
                        ? "bottom center"
                        : "bottom center"
                    }
                    show={showCancleTooltip}
                    textBoxWidth="36px"
                    arrowAlign="center"
                    padding="5px 5px 5px 7px"
                    borderRadius="5px"
                    static
                  >
                    <span className="work-order-preview-tooltip">
                      {t.common.close}
                    </span>
                  </ToolTip>
                </span>
              </div>
            </div>
          </div>
          {buttonStatus == 1 ? (
            <Dimmer active inverted>
              <Loader inverted content={t.common.loading} />
            </Dimmer>
          ) : (
            ""
          )}
          <div className="body">
            <FileUpload
              onFileChange={onFileChange}
              name="image"
              setImageSrc={setImageSrc}
              setFile={setFile}
              attachments={attachments}
              setAttachments={setAttachments}
            />

            {imageSrc && (
              <ImageCrop
                // ratio={1 / 1}
                src={imageSrc}
                minWidth={20}
                minHeight={20}
                fileData={file}
                onAccept={async (croppedImageUrl) => {
                  let CroppedFile = new File([croppedImageUrl], file.name, {
                    type: file.type,
                  });

                  var randomnumber =
                    Math.floor(Math.random() * (0 - 100 + 1)) + 100;

                  const personalPictureResponse = await uploadFile([
                    CroppedFile,
                  ]);

                  if (personalPictureResponse?.status == 200) {
                    let fileData = personalPictureResponse?.data[0]?.url;
                    setPersonalImgId(personalPictureResponse.data[0].id);
                    setImageSrc("");
                    setFile("");
                    setAttachments({
                      ...attachments,
                      ["image"]: {
                        file: CroppedFile,
                        id: randomnumber,
                        name: CroppedFile.name,
                        type: CroppedFile.type,
                        cancelPopup: false,
                        isChanged: true,
                        url: fileData ? fileData : null,
                      },
                    });
                  } else {
                    toast.error(t.common.something_wrong);
                  }
                }}
                onCancel={() => {
                  setImageSrc("");
                  setFile("");
                }}
              />
            )}
            <Form.Field>
              <label className="label-item mt-5">
                {t.teams.team_info_form.team_name}
                <Asterisk color="#172B4D" />
              </label>
              <Input
                autoComplete="new-password"
                fluid
                placeholder={t.teams.team_info_form.add_team}
                value={data.name}
                onChange={onValuesChange("name")}
                error={validation.name.error && validation.name.skipped}
                onBlur={onBlur("name")}
              />
              {validation.name.error && validation.name.skipped ? (
                <div className="label-error">{validation.name.message}</div>
              ) : (
                ""
              )}
            </Form.Field>

           <Form className="text-area-container">
              <Form.Field>
                <label className="label-item">
                  {t.teams.team_info_form.description}
                </label>
                <TextArea
                  autoComplete="new-password"
                  value={data.description}
                  onChange={onValuesChange("description")}
                  rows={4}
                  fluid
                  placeholder={t.teams.team_info_form.description_placeholder}
                  error={validation.description.error && validation.description.skipped}
                  onBlur={onBlur("description")}
                />
                {validation.description.error && validation.description.skipped ? (
                    <div className="label-error">{validation.description.message}</div>
                ) : (
                    ""
                )}
              </Form.Field>
            </Form>

            <Form.Field>
              <label className="label-item">
                {t.teams.team_info_form.team_superior}
                <Asterisk color="#172B4D" />
              </label>
              <Dropdown
                placeholder={t.teams.team_info_form.add_team_superior}
                fluid
                search
                clearable
                selection
                noResultsMessage={t.common.no_results_found}
                options={options.supervisors}
                value={data.superior}
                onChange={onValuesChange("superior")}
                onOpen={fetchSupervisorsData}
                error={validation.superior.error && validation.superior.skipped}
                onBlur={onBlur("superior")}
              />
              {validation.superior.error && validation.superior.skipped ? (
                <div className="label-error">{validation.superior.message}</div>
              ) : (
                ""
              )}
            </Form.Field>

            <Form.Field>
              <label className="label-item">
                {t.teams.team_info_form.team_members}
                <Asterisk color="#172B4D" />
              </label>
              <Dropdown
                placeholder={t.teams.team_info_form.add_team_members}
                fluid
                search
                selection
                noResultsMessage={t.common.no_results_found}
                multiple
                options={options.users}
                value={data.users}
                onOpen={fetchUsersData}
                onChange={onValuesChange("users")}
                error={validation.users.error && validation.users.skipped}
                onBlur={onBlur("users")}
              />
              {validation.users.error && validation.users.skipped ? (
                <div className="label-error error">
                  {validation.users.message}
                </div>
              ) : (
                ""
              )}
            </Form.Field>

            <Form.Field>
              <label className="label-item">
                {t.teams.team_info_form.customer}
                <Asterisk color="#172B4D" />
              </label>
              <Dropdown
                placeholder={t.teams.team_info_form.customer_placeholder}
                search
                fluid
                multiple
                noResultsMessage={t.common.no_results_found}
                selection
                onAddItem={handleAddCustomer}
                options={options.customers}
                value={data.customers}
                error={validation.customers.error && validation.customers.skipped}
                onChange={onValuesChange("customers")}
                onBlur={onBlur("customers")}
              />
              {validation.customers.error && validation.customers.skipped ? (
                  <div className="label-error error">
                    {validation.customers.message}
                  </div>
              ) : (
                  ""
              )}
            </Form.Field>
            {/* Location  */}
            <Form.Field>
              <label className="label-item">
                {t.workOrders.form.location}
                <Asterisk color="#172B4D" />{" "}
                {/* <Icon name="asterisk" color="red" size="small" /> */}
              </label>
              <Dropdown
                placeholder={t.teams.team_info_form.location_placeholder}
                fluid
                selection
                className="people-dropdown"
                multiple
                search
                noResultsMessage={t.common.no_results_found}
                onAddItem={handleAddLocation}
                disabled={fetchLocOptions}
                options={options.locations.options}
                value={data.locations}
                onChange={onValuesChange("locations")}
                error={
                  validation.locations.error && validation.locations.skipped
                }
                onBlur={(e) => {
                  if (
                    validation.locations.pattern(data.locations) &&
                    matchingCustomers?.length == 0
                  ) {
                    setValidation((prev) => {
                      return {
                        ...prev,
                        locations: {
                          ...validation.locations,
                          error: false,
                          skipped: true,
                        },
                      };
                    });
                  } else {
                    setValidation((prev) => {
                      return {
                        ...prev,
                        locations: {
                          ...validation.locations,
                          error: true,
                          skipped: true,
                        },
                      };
                    });
                  }
                }}
              />
              {validation.locations.error && validation.locations.skipped ? (
                <div className="label-error error">
                  {validation.locations.message}
                </div>
              ) : (
                ""
              )}
            </Form.Field>
            <div className="form-button-container mt-10">
              <button
                onClick={() =>
                  initChange ? setNewCancelModal(true) : cancelHandler()
                }
                className="form-action-button"
              >
                {t.assets.form.cancel}
              </button>

              <button
                onClick={updateTeamHandler}
                className="form-action-button blue"
                disabled={buttonStatus == 1}
              >
                {t.common.edit}
              </button>
            </div>
          </div>
        </Resizable>
      </div>
      <div
        className={
          toggled ? "aside-modal-background active" : "aside-modal-background"
        }
        onClick={() => (initChange ? setNewCancelModal(true) : cancelHandler())}
      ></div>

      <NewCancelModal
        yesCallback={() => {
          cancelHandler();
        }}
        title={t.parts.form.changes}
      >
        <p className="cancel-child">  {t.common.cancel_2statement}</p>
      </NewCancelModal>

      <AddCustomerModal
        toggled={addCustomerModal}
        untoggle={() => {
          toggleAddCustomerModal(false);
        }}
        returnAddCustomer={returnAddCustomer}
        title={customerText}
      />

      <AddLocationModal
        toggled={addLocationModal}
        untoggle={() => {
          toggleAddLocationModal(false);
        }}
        customer={data.customers}
        returnAddLocation={returnAddLocation}
        title={locationText}
      />
    </>
  );
}

export default Edit;
